import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Pillars from "@/components/landing/Pillars";
import Gallery from "@/components/landing/Gallery";
import Services from "@/components/landing/Services";
import About from "@/components/landing/About";
import HowItWorks from "@/components/landing/HowItWorks";
import Audiences from "@/components/landing/Audiences";
import ServiceArea from "@/components/landing/ServiceArea";
import Testimonials from "@/components/landing/Testimonials";
import BookingSection from "@/components/landing/BookingSection";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#FAF8F5] text-[#242A2E]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Pillars />
        <Gallery />
        <Services />
        <About />
        <HowItWorks />
        <Audiences />
        <ServiceArea />
        <Testimonials />
        <BookingSection />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
